// frontend/src/services/dashboardService.ts
import axiosInstance from '../utils/axiosConfig';
import type { 
  DashboardResponse, 
  DashboardFilters, 
  GenresResponse 
} from '../types/PPDash';

/**
 * Fetch dashboard performance intelligence data
 */
export const fetchDashboardData = async (filters?: DashboardFilters): Promise<DashboardResponse> => {
  try {
    const params = new URLSearchParams();
    
    if (filters?.startDate) {
      params.append('startDate', filters.startDate);
    }
    if (filters?.endDate) {
      params.append('endDate', filters.endDate);
    }
    if (filters?.genre && filters.genre !== 'all') {
      params.append('genre', filters.genre);
    }

    const response = await axiosInstance.get(
      `/api/dashboard/performance-intelligence?${params.toString()}`
    );

    return response.data;
  } catch (error: any) {
    console.error('Error fetching dashboard data:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to fetch dashboard data',
      message: error.response?.data?.message || error.message
    };
  }
};

/**
 * Fetch available genres for filter dropdown
 */
export const fetchGenres = async (): Promise<GenresResponse> => {
  try {
    const response = await axiosInstance.get('/api/dashboard/genres');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching genres:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to fetch genres',
      message: error.response?.data?.message || error.message
    };
  }
};